var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DropdownSelect, Modal, ModalBody, ModalFoot, ModalHead, SelectItem, Tooltip, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import { BulkValidationErrors, BulkValidationTypes, } from 'components/conversationsOverview/reducers/conversationsOverviewTypes';
import { BulkActionsAddInternalNote } from './addInternalNote/bulkActionsAddInternalNote';
import styles from './bulkActionsModal.module.scss';
import { BulkActionsCancelCSAT } from './cancelCSAT/bulkActionsCancelCSAT';
import { BulkActionsClose } from './close/bulkActionsClose';
import { BulkActionsSendReply } from './sendReply/bulkActionsSendReply';
import { BulkActionsTag } from './tag/bulkActionsTag';
import { BulkActionsTransferToQueue } from './transferToQueue/bulkActionsTransferToQueue';
const BULK_ACTIONS_DEFAULT_LIMIT = 50;
const actionItems = {
    addInternalNote: 'Add internal note',
    // claim: 'Claim',
    close: 'Close',
    sendReply: 'Send reply',
    addTag: 'Add tag',
    removeTag: 'Remove tag',
    transferToQueue: 'Transfer to queue',
    cancelCSAT: 'Cancel CSAT',
};
export class BulkActionsModal extends PureComponent {
    removeActionAddTag() {
        this.props.removeAction('addTag');
    }
    removeActionRemoveTag() {
        this.props.removeAction('removeTag');
    }
    removeActionClose() {
        this.props.removeAction('close');
    }
    removeActionSendReply() {
        this.props.removeAction('sendReply');
    }
    removeActionAddInternalNote() {
        this.props.removeAction('addInternalNote');
    }
    removeActionTransferToQueue() {
        this.props.removeAction('transferToQueue');
    }
    removeActionCancelCSAT() {
        this.props.removeAction('cancelCSAT');
    }
    selectAction(action) {
        this.props.addAction(action.id);
    }
    getTooltipActionItems() {
        const tooltipItems = {};
        const sendReplyTooltipProps = this.getSendReplyTooltipProps();
        if (sendReplyTooltipProps) {
            tooltipItems.sendReply = sendReplyTooltipProps;
        }
        return tooltipItems;
    }
    getSendReplyTooltipProps() {
        const { bulkValidation } = this.props;
        const sendReplyBulkValidation = bulkValidation.filter((validation) => validation.validation_type === BulkValidationTypes.SEND_REPLY);
        if (!sendReplyBulkValidation.length) {
            return null;
        }
        const head = 'Send reply is disabled';
        const contentItems = sendReplyBulkValidation.map((validation) => {
            switch (validation.error) {
                case BulkValidationErrors.FACEBOOK_MESSENGER_OUTBOUND_EXPIRED:
                    return (_jsx("li", { children: this.getSendReplyValidationMessage(validation.csids, 'expired Facebook messenger') }, validation.error));
                case BulkValidationErrors.PHONE_CONVERSATION_NOT_SUPPORTED:
                    return (_jsx("li", { children: this.getSendReplyValidationMessage(validation.csids, 'phone') }, validation.error));
                case BulkValidationErrors.CALLBACK_CONVERSATION_NOT_SUPPORTED:
                    return (_jsx("li", { children: this.getSendReplyValidationMessage(validation.csids, 'callback') }, validation.error));
                case BulkValidationErrors.VOICEMAIL_CONVERSATION_NOT_SUPPORTED:
                    return (_jsx("li", { children: this.getSendReplyValidationMessage(validation.csids, 'voicemail') }, validation.error));
                case BulkValidationErrors.WHATSAPP_OUTBOUND_EXPIRED:
                    return (_jsx("li", { children: this.getSendReplyValidationMessage(validation.csids, 'expired WhatsApp') }, validation.error));
                default:
                    return undefined;
            }
        });
        return {
            wrap: 'div',
            wrapProps: { className: styles.tooltipItemWrapper },
            head,
            content: (_jsx("ul", Object.assign({ style: { marginLeft: '-24px', textAlign: 'left' } }, { children: contentItems }))),
            children: '',
        };
    }
    getSendReplyValidationMessage(csids, message) {
        return `${csids.length} ${message} ${csids.length === 1 ? 'conversation is' : 'conversations are'} included in the selected conversations`;
    }
    getDisabledActionItems() {
        const { bulkValidation } = this.props;
        const disabledActions = [];
        if (bulkValidation.find((validation) => validation.validation_type === BulkValidationTypes.SEND_REPLY)) {
            disabledActions.push('sendReply');
        }
        return disabledActions;
    }
    getFormError() {
        const { selectedActions, selectedTagsToAdd, selectedTagsToRemove, replyMessage, internalNote, selectedQueue, csids, hasHighLimitBulkActions, } = this.props;
        if (!hasHighLimitBulkActions && csids.length > BULK_ACTIONS_DEFAULT_LIMIT) {
            return `Cannot apply bulk actions on more than ${BULK_ACTIONS_DEFAULT_LIMIT} items at a time`;
        }
        if (!selectedActions.length) {
            return 'There are no actions to apply';
        }
        if (selectedActions.includes('addTag') && !selectedTagsToAdd.length) {
            return `There are no tags to add in the "${actionItems.addTag}" action`;
        }
        if (selectedActions.includes('removeTag') && !selectedTagsToRemove.length) {
            return `There are no tags to remove in the "${actionItems.removeTag}" action`;
        }
        if (selectedActions.includes('sendReply') &&
            !replyMessage.htmlText.length) {
            return `There is no message in the "${actionItems.sendReply}" action`;
        }
        if (selectedActions.includes('addInternalNote') && !internalNote.length) {
            return `There is no message in the "${actionItems.addInternalNote}" action`;
        }
        if (selectedActions.includes('transferToQueue') && selectedQueue === null) {
            return `There is no queue selected in the "${actionItems.transferToQueue}" action`;
        }
        return null;
    }
    onBulkUpdate() {
        const { selectedActions, start, csids, location } = this.props;
        start();
        analytics.bulkActionsUpdateClicked({
            selectedActions,
            selectedActionsCount: selectedActions.length,
            conversationsCount: csids.length,
            location,
            modalVersion: '1',
        });
    }
    render() {
        const { isOpen, selectedActions, unselectedActions, csids, replyMessage, internalNote, selectedQueue, close, onAddTagsSelectionChanged, onRemoveTagsSelectionChanged, setReplyMessage, setInternalNote, setSelectedQueue, } = this.props;
        if (!csids.length) {
            return null; // do not mount the modal when no conversation is selected
        }
        const dropdownItems = unselectedActions.map((action) => ({
            id: action,
            name: actionItems[action],
        }));
        const formError = this.getFormError();
        return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: close }, { children: [_jsx(ModalHead, { title: "Update conversations in bulk", onClose: close }), _jsxs(ModalBody, Object.assign({ className: styles.bulkActionsModal }, { children: [_jsx("p", { children: "Choose which actions you would like to apply to the conversations that you have selected. You can choose one action or add multiple actions to be applied after each other." }), selectedActions.map((action) => {
                            switch (action) {
                                case 'addTag':
                                    return (_jsx(BulkActionsTag, { allowCreatingNewTag: true, title: actionItems.addTag, onRemove: this.removeActionAddTag, onSelectionChanged: onAddTagsSelectionChanged }, action));
                                case 'removeTag':
                                    return (_jsx(BulkActionsTag, { title: actionItems.removeTag, onRemove: this.removeActionRemoveTag, onSelectionChanged: onRemoveTagsSelectionChanged }, action));
                                case 'close':
                                    return (_jsx(BulkActionsClose, { onRemove: this.removeActionClose }, action));
                                case 'sendReply':
                                    return (_jsx(BulkActionsSendReply, { message: replyMessage, setMessage: setReplyMessage, onRemove: this.removeActionSendReply }, action));
                                case 'transferToQueue':
                                    return (_jsx(BulkActionsTransferToQueue, { onRemove: this.removeActionTransferToQueue, selectedQueue: selectedQueue, setSelectedQueue: setSelectedQueue }, action));
                                case 'addInternalNote':
                                    return (_jsx(BulkActionsAddInternalNote, { note: internalNote, setNote: setInternalNote, onRemove: this.removeActionAddInternalNote }, action));
                                case 'cancelCSAT':
                                    return (_jsx(BulkActionsCancelCSAT, { onRemove: this.removeActionCancelCSAT }, action));
                                default:
                                    return null;
                            }
                        }), _jsx("div", Object.assign({ className: styles.actionsDropdown }, { children: _jsx(DropdownSelect, Object.assign({ containerProps: { className: styles.actionsDropdownContainer }, items: dropdownItems, disabledItems: this.getDisabledActionItems(), tooltipItems: this.getTooltipActionItems(), itemComponent: SelectItem, noArrow: false, onSelect: this.selectAction, itemsDisplayCount: dropdownItems.length }, { children: "Add action" })) }))] })), _jsxs(ModalFoot, { children: [_jsx(Button, Object.assign({ variant: "secondary", className: styles.cancelButton, onClick: close }, { children: "Cancel" })), _jsx(Tooltip, Object.assign({ content: formError, disabled: !formError, wrap: "div" }, { children: _jsxs(Button, Object.assign({ onClick: this.onBulkUpdate, disabled: !!formError }, { children: ["Update (", csids.length, ")"] })) }))] })] })));
    }
}
__decorate([
    boundMethod
], BulkActionsModal.prototype, "removeActionAddTag", null);
__decorate([
    boundMethod
], BulkActionsModal.prototype, "removeActionRemoveTag", null);
__decorate([
    boundMethod
], BulkActionsModal.prototype, "removeActionClose", null);
__decorate([
    boundMethod
], BulkActionsModal.prototype, "removeActionSendReply", null);
__decorate([
    boundMethod
], BulkActionsModal.prototype, "removeActionAddInternalNote", null);
__decorate([
    boundMethod
], BulkActionsModal.prototype, "removeActionTransferToQueue", null);
__decorate([
    boundMethod
], BulkActionsModal.prototype, "removeActionCancelCSAT", null);
__decorate([
    boundMethod
], BulkActionsModal.prototype, "selectAction", null);
__decorate([
    boundMethod
], BulkActionsModal.prototype, "onBulkUpdate", null);
